import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import './EventsContent.css';
import FrenchData from '../data/Events/FrenchData.json';
import SpanishData from '../data/Events/SpanishData.json';
import GermanData from '../data/Events/GermanData.json';
import ItalianData from '../data/Events/ItalianData.json';
import JapaneseData from '../data/Events/JapaneseData.json';
import FloatIcon from "./FloatIcons/FloatIcons";
import VideoComponent from "./VideoComponent";

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}




function EventsContent({ value, setValue }) {

    const [ID, setID] = useState({
        frenchID: 1,
        spanishID: 1,
        italianID: 1,
        germanID: 1,
        japaneseID: 1
    });

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    let [langData, setLangData] = useState(FrenchData);

    useEffect(() => {
        if (value == 0) {
            setLangData(FrenchData);
        } else if (value == 1) {
            setLangData(SpanishData);
        } else if (value == 2) {
            setLangData(ItalianData);
        } else if (value == 3) {
            setLangData(GermanData);
        } else
            setLangData(JapaneseData);
    }, [value]);



    function handleChangeID(id, lang) {
        // console.log("inside handle change id")

        if (lang.split(" ")[0] == 'French') {
            console.log(id, "id inside func")
            setID({ ...ID, frenchID: id })
        } else if (lang.split(" ")[0] == 'Spanish') {
            setID({ ...ID, spanishID: id })
        } else if (lang.split(" ")[0] == 'Italian') {
            setID({ ...ID, italianID: id })
        }
        else if (lang.split(" ")[0] == 'German') {
            setID({ ...ID, germanID: id })
        } else if (lang.split(" ")[0] == 'Japanese') {
            setID({ ...ID, japaneseID: id })
        }
    }

    return (
        <>
            <div className="floatIconsContainer">
                <FloatIcon />
            </div>
            <div className="fame-banner-container">
                <img src="/images/Events/Banner.png" alt="events-banner" className="banner-walloffame" />
                <h1>Learning Bytes</h1>
            </div>


            <div className="events-outer-container">
                <div className="events-container">
                    <Box sx={{ width: '100%' }}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                                <Tab label="French" {...a11yProps(0)} />
                                <Tab label="Spanish" {...a11yProps(1)} />
                                <Tab label="Italian" {...a11yProps(2)} />
                                <Tab label="German" {...a11yProps(3)} />
                                <Tab label="Japanese" {...a11yProps(4)} />
                            </Tabs>
                        </Box>
                        <CustomTabPanel value={value} index={0}>
                            <>

                                {FrenchData.filter((item) => item.id === ID.frenchID).map((item) => {
                                    return (
                                        <div className="tab-content">
                                            <div className="video-container">
                                                {console.log(item, "itemmm")}
                                                {/* <img src={item.videoPath} alt="" className="videoThumbnail" /> */}
                                                <VideoComponent url={item.videoPath} />
                                                <h4 className="name">{item.name}</h4>
                                                <p className="langGrade">{item.langGrade}</p>
                                                <p className="storyDesc">{item.storyDesc}</p>
                                            </div>
                                        </div>
                                    )
                                })
                                }
                            </>
                        </CustomTabPanel>
                        <CustomTabPanel value={value} index={1}>
                            <>
                                {SpanishData.filter((item) => item.id === ID.spanishID).map((item) => {
                                    return (
                                        <div className="tab-content">
                                            <div className="video-container">
                                                {/* <img src={item.videoPath} alt="" className="videoThumbnail" /> */}
                                                <VideoComponent url={item.videoPath} />
                                                <h4 className="name">{item.name}</h4>
                                                <p className="langGrade">{item.langGrade}</p>
                                                <p className="storyDesc">{item.storyDesc}</p>
                                            </div>
                                        </div>
                                    )
                                })
                                }
                            </>
                        </CustomTabPanel>
                        <CustomTabPanel value={value} index={2}>
                            <>
                                {ItalianData.filter((item) => item.id === ID.italianID).map((item) => {
                                    return (
                                        <div className="tab-content">
                                            <div className="video-container">
                                                {/* <img src={item.videoPath} alt="" className="videoThumbnail" /> */}
                                                <VideoComponent url={item.videoPath} />
                                                <h4 className="name">{item.name}</h4>
                                                <p className="langGrade">{item.langGrade}</p>
                                                <p className="storyDesc">{item.storyDesc}</p>
                                            </div>
                                        </div>
                                    )
                                })
                                }
                            </>
                        </CustomTabPanel>
                        <CustomTabPanel value={value} index={3}>
                            <>
                                {GermanData.filter((item) => item.id === ID.germanID).map((item) => {
                                    return (
                                        <div className="tab-content">
                                            <div className="video-container">
                                                {/* <img src={item.videoPath} alt="" className="videoThumbnail" /> */}
                                                <VideoComponent url={item.videoPath} />
                                                <h4 className="name">{item.name}</h4>
                                                <p className="langGrade">{item.langGrade}</p>
                                                <p className="storyDesc">{item.storyDesc}</p>
                                            </div>
                                        </div>
                                    )
                                })
                                }
                            </>
                        </CustomTabPanel>
                        <CustomTabPanel value={value} index={4}>
                            <>
                                {JapaneseData.filter((item) => item.id === ID.japaneseID).map((item) => {
                                    return (
                                        <div className="tab-content">
                                            <div className="video-container">
                                                {/* <img src={item.videoPath} alt="" className="videoThumbnail" /> */}
                                                <VideoComponent url={item.videoPath} />
                                                <h4 className="name">{item.name}</h4>
                                                <p className="langGrade">{item.langGrade}</p>
                                                <p className="storyDesc">{item.storyDesc}</p>
                                            </div>
                                        </div>
                                    )
                                })
                                }
                            </>
                        </CustomTabPanel>
                    </Box>
                </div>
                <div className="stories-container">
                    <h4>Watch a video</h4>
                    <div className="stories-box">
                        {
                            langData.map((item) => {
                                return (
                                    <div className="stories-wrap" onClick={() => handleChangeID(item.id, item.langGrade)}>
                                        <img src={process.env.PUBLIC_URL + item.profilePicture} alt="profile-picture" className="story-picture" />
                                        <div className="story-content">
                                            <h5 className="story-name">{item.name}</h5>
                                            <p className="story-storyDesc">{item.storyDesc}</p>
                                            <span className="story-langGrade">{item.langGrade}</span>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        </>
    );
}

export default EventsContent;
